import './Chat.css';

import React, { useContext, useEffect, useState, useMemo } from "react";
import { toast } from "react-toastify";
import http from "../../Services/httpService";
import ChatBox from './ChatBox'
import { jwtDecode } from "jwt-decode"; 
export default function Chat({onMessage,onCloseChatBox,showBox}) {
    
    const [id, setId] = useState(0);
  
    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (!jwt)
            return;
        const currentUser = jwtDecode(jwt);
        console.log('currentUser', currentUser)
        //currentUser.DisplayName 
        setId(currentUser['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier']);       
    }, []);

    
   
    return (
        <>
            {/*!showBox &&
                <div
                    id="box-widget-icon"
                    onClick={e => {
                        e.preventDefault();
                        console.log('sss', e)
                        setShowBox(true)
                        console.log('showBox2', showBox)
                    }}>
                    <span id="unreadMessages" className="position-absolute to1p-0 start-100 translate-middle badge rounded-pill bg-danger">
                        99+
                        <span className="visually-hidden">unread messages</span>
                    </span>
                    <div id="widget-icon">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 120 120">
                            <path d="M60.19,53.75a3,3,0,1,0,3.06,3A3,3,0,0,0,60.19,53.75Zm-11.37,0a3,3,0,1,0,3.06,3A3,3,0,0,0,48.81,53.75Zm45.94,4A35,35,0,1,0,52.75,92v12.76s14.55-4.25,30.53-19.28C94.68,74.74,94.75,59.41,94.75,59.41l0,0C94.74,58.87,94.75,58.3,94.75,57.72Zm-10.14.6s0,10.64-8,18.09A57.93,57.93,0,0,1,53,89.8V80.34A24.29,24.29,0,1,1,84.61,57.16c0,.4,0,.8,0,1.19ZM70.69,53.75a3,3,0,1,0,3.06,3A3,3,0,0,0,70.69,53.75Z"
                                transform="translate(0.25 0.25)"
                                style={{ fill: "#ffffff" }}>
                            </path>
                        </svg>
                    </div>
                </div>
            */}
            {showBox && <ChatBox
                idd={id}
                onClose={e => { onCloseChatBox(e) }} 
                onMessage={onMessage}/>}
                
        </>
    );

}